import { AiPurchaseOrderPageShell } from './components/AiPurchaseOrderPageShell/AiPurchaseOrderPageShell'
import { AiRecommendationContent } from './components/AiRecommendationContent/AiRecommendationContent'

export const AiPurchaseOrderRecommendations = () => (
  <AiPurchaseOrderPageShell>
    <AiRecommendationContent />
  </AiPurchaseOrderPageShell>
)
